import Page from './index';
import { authRoles } from 'app/auth';

export default {
settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
	},
	// auth: authRoles.onlyGuest,
	routes: [
		{
			path: '/companies',
			exact: true,
			component: Page.Layout
		},
		{
			path: '/companies/detail/:id',
			exact: true,
			component: Page.CompanyDetail
		}
	]
};